import { useState} from 'react';
import useReplaceUrl from '../hooks/useReplaceUrl';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function ChapterImage({ section, title, description, text, image, imageSize, imagePosition, imageHeight, images, imageNumber }) {
  const [selectedImage, setSelectedImage] = useState(null);
  
  useReplaceUrl(section);

  return (
    <div className="chapter_image">
      <div className="container mainMargin">
        <div className="row">
          <div className="col-xl-1 mb-3">
            <Link to="/capitulos">
              <img 
                src={`https://www.diadelavida.com/images/layout/chapters_back.png?${Date.now()}`} 
              />
            </Link>
          </div>
          <div
            className={`${images.length < 3 ? 'col-xl-9 col-md-10' : 'col-xl-8 col-md-9'} mb-3`}
          >
            <div className="page shadow mainPage">
              <h2 style={{backgroundImage:  `url(${imageNumber})`}}>{title}</h2>
              <h3 className='Amatic'>{description}</h3>
              <div className='main_text' dangerouslySetInnerHTML={{ __html: text }} />
              <div 
                className="image-decoration"
                style={{ backgroundImage: `url(${image})`, backgroundSize: `${imageSize}`, backgroundPosition: `${imagePosition}`, height: `${imageHeight}px`, minHeight: '100px' }}
                ></div>
            </div>
          </div>
          <div
            className={`${images.length < 3 ? 'col-md-2' : 'col-md-3'} mb-5 page shadow`}
          >
            <div className="row">
              {images.map((image) => (
                <div
                  className={`col-6 ${images.length < 3 ? 'col-md-12' : ''}`}
                  key={image.id}>
                  <div
                    className="image"
                    onClick={() => setSelectedImage(image)}
                    role="button"
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="img-fluid"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Modal */}
        <Modal
          show={!!selectedImage}
          onHide={() => setSelectedImage(null)}
          size="lg"
          centered
          className="tall-modal" 
        >
          <Modal.Header closeButton>
            {/* <Modal.Title>Image Details</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            {selectedImage && (
              <>
                <img
                  src={selectedImage.src}
                  alt={selectedImage.alt}
                  className="img-fluid mb-3"
                />
                <p>{selectedImage.description}</p>
              </>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}